module.exports = __webpack_public_path__ + "img/10.9d5dd4f1.jpg";